// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#active {
  background-color: #d4e9df;
  border-radius: 6px;
}
#active .my-sidebar__menu__title__expand {
  font-weight: 600 !important;
  color: #26512f !important;
}

#activeColorIcon {
  color: #26512f !important;
}

#active1 {
  background-color: #d4e9df;
  border-radius: 6px;
  color: #26512f !important;
  margin: 5px 0 5px 0 !important;
}

.my-sidebar {
  margin: -5px 10px 0px 0px;
  background-color: #ffffff;
  height: 100vh;
  border-right: 2px solid #e1e1e1;
  padding: 5px;
}
.my-sidebar #active .MuiAccordionSummary-content .my-sidebar__menu__title {
  font-weight: 600 !important;
  color: #26512f !important;
}
.my-sidebar #active .MuiAccordionSummary-content .my-sidebar__menu__icon img {
  filter: invert(21%) sepia(88%) saturate(317%) hue-rotate(81deg) brightness(96%) contrast(87%);
}
.my-sidebar #active1 .MuiAccordionSummary-content .my-sidebar__menu__title {
  font-weight: 600 !important;
  color: #26512f !important;
}
.my-sidebar #active1 .MuiAccordionSummary-content .my-sidebar__menu__icon img {
  filter: invert(21%) sepia(88%) saturate(317%) hue-rotate(81deg) brightness(96%) contrast(87%);
}
.my-sidebar .Mui-expanded {
  margin: 0 !important;
}
.my-sidebar .MuiAccordion-root {
  box-shadow: none;
  background-color: #fefeff;
}
.my-sidebar .MuiAccordion-root::before {
  display: none;
}
.my-sidebar .MuiAccordionSummary-root {
  min-height: 30px;
  padding: 3px 3px;
  margin-bottom: 5px;
  border-radius: 6px;
  background: #fefeff;
}
.my-sidebar .MuiAccordionSummary-root:hover {
  background-color: #d4e9df;
  border-radius: 6px;
}
.my-sidebar .MuiAccordionSummary-root.Mui-expanded {
  min-height: 30px;
  margin-bottom: 15px !important;
  background-color: #d4e9df;
}
.my-sidebar .MuiAccordionSummary-root.Mui-expanded .my-sidebar__menu__title {
  font-weight: 600 !important;
  color: #26512f !important;
}
.my-sidebar .MuiAccordionSummary-root.Mui-expanded .my-sidebar__menu__icon img {
  filter: invert(21%) sepia(88%) saturate(317%) hue-rotate(81deg) brightness(96%) contrast(87%);
}
.my-sidebar .MuiAccordionSummary-root.Mui-expanded:hover {
  background-color: #d4e9df;
  border-radius: 6px;
}
.my-sidebar .MuiAccordionSummary-content {
  margin: 0px;
}
.my-sidebar .MuiAccordionDetails-root {
  padding: 10px 0px 10px 20px;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
}
.my-sidebar .MuiAccordionDetails-root:hover {
  background-color: #d4e9df;
  border-radius: 6px;
}
.my-sidebar .MuiAccordionSummary-expandIconWrapper {
  color: #000000;
}
.my-sidebar .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
  color: #000000;
  transform: rotate(90deg);
}
.my-sidebar__menu {
  display: flex;
  flex-direction: column;
  gap: 5px 0;
}
.my-sidebar__menu__icon {
  color: #000000;
  margin-bottom: 2px;
}
.my-sidebar__menu__title {
  padding-left: 5px;
  padding-top: 5px;
  display: flex;
  color: #000000;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
}
.my-sidebar__menu__title__expand {
  padding-left: 0px;
  font-size: 13px;
  display: block;
  color: #000000;
  width: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.my-sidebar__menu__title__expand__detail {
  padding-left: 5px;
  font-size: 13px;
  display: flex;
  align-items: center;
  color: white;
}
.my-sidebar__hrcustom {
  border-top: 1px solid #ffffff !important;
  background-color: #f6f6f7;
}

.title-tc {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  text-transform: uppercase;
  color: #8f3232;
}

.title-pm {
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  text-transform: uppercase;
  color: #2b713a;
}

.title-tooltip {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  padding: 5px 10px 5px 10px;
  width: 500;
}
.title-tooltip:hover {
  background-color: #727b85;
}

.title-tooltip- {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;AAAE;EACE,2BAAA;EACA,yBAAA;AAEJ;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,8BAAA;AAGF;;AAAA;EACE,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,+BAAA;EACA,YAAA;AAGF;AAAM;EACE,2BAAA;EACA,yBAAA;AAER;AAAM;EACE,6FAAA;AAER;AAKM;EACE,2BAAA;EACA,yBAAA;AAHR;AAKM;EACE,6FAAA;AAHR;AAQE;EACE,oBAAA;AANJ;AASE;EACE,gBAAA;EACA,yBAAA;AAPJ;AAUE;EACE,aAAA;AARJ;AAWE;EACE,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,yBAAA;EACA,kBAAA;AAXJ;AAcE;EACE,gBAAA;EACA,8BAAA;EACA,yBAAA;AAZJ;AAaI;EACE,2BAAA;EACA,yBAAA;AAXN;AAaI;EACE,6FAAA;AAXN;AAgBE;EACE,yBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,WAAA;AAfJ;AAkBE;EACE,2BAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;AAhBJ;AAmBE;EACE,yBAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,cAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,wBAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AApBJ;AAqBI;EACE,cAAA;EACA,kBAAA;AAnBN;AAsBI;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AApBN;AAuBI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EAEA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAtBN;AAyBI;EACE,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAvBN;AA2BE;EACE,wCAAA;EACA,yBAAA;AAzBJ;;AA6BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AA1BF;;AA4BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,UAAA;AAzBF;AA0BE;EACE,yBAAA;AAxBJ;;AA2BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAxBF","sourcesContent":["#active {\r\n  background-color: #d4e9df;\r\n  border-radius: 6px;\r\n  .my-sidebar__menu__title__expand {\r\n    font-weight: 600 !important;\r\n    color: #26512f !important;\r\n  }\r\n}\r\n#activeColorIcon {\r\n  color: #26512f !important;\r\n}\r\n#active1 {\r\n  background-color: #d4e9df;\r\n  border-radius: 6px;\r\n  color: #26512f !important;\r\n  margin: 5px 0 5px 0 !important;\r\n}\r\n\r\n.my-sidebar {\r\n  margin: -5px 10px 0px 0px;\r\n  background-color: #ffffff;\r\n  height: 100vh;\r\n  border-right: 2px solid #e1e1e1;\r\n  padding: 5px;\r\n  #active {\r\n    .MuiAccordionSummary-content {\r\n      .my-sidebar__menu__title {\r\n        font-weight: 600 !important;\r\n        color: #26512f !important;\r\n      }\r\n      .my-sidebar__menu__icon img {\r\n        filter: invert(21%) sepia(88%) saturate(317%) hue-rotate(81deg)\r\n          brightness(96%) contrast(87%);\r\n      }\r\n    }\r\n  }\r\n  #active1 {\r\n    .MuiAccordionSummary-content {\r\n      .my-sidebar__menu__title {\r\n        font-weight: 600 !important;\r\n        color: #26512f !important;\r\n      }\r\n      .my-sidebar__menu__icon img {\r\n        filter: invert(21%) sepia(88%) saturate(317%) hue-rotate(81deg)\r\n          brightness(96%) contrast(87%);\r\n      }\r\n    }\r\n  }\r\n  .Mui-expanded {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .MuiAccordion-root {\r\n    box-shadow: none;\r\n    background-color: #fefeff;\r\n  }\r\n\r\n  .MuiAccordion-root::before {\r\n    display: none;\r\n  }\r\n\r\n  .MuiAccordionSummary-root {\r\n    min-height: 30px;\r\n    padding: 3px 3px;\r\n    // margin-top: 5px;\r\n    margin-bottom: 5px;\r\n    border-radius: 6px;\r\n    background: #fefeff;\r\n  }\r\n\r\n  .MuiAccordionSummary-root:hover {\r\n    background-color: #d4e9df;\r\n    border-radius: 6px;\r\n  }\r\n\r\n  .MuiAccordionSummary-root.Mui-expanded {\r\n    min-height: 30px;\r\n    margin-bottom: 15px !important;\r\n    background-color: #d4e9df;\r\n    .my-sidebar__menu__title {\r\n      font-weight: 600 !important;\r\n      color: #26512f !important;\r\n    }\r\n    .my-sidebar__menu__icon img {\r\n      filter: invert(21%) sepia(88%) saturate(317%) hue-rotate(81deg)\r\n        brightness(96%) contrast(87%);\r\n    }\r\n  }\r\n\r\n  .MuiAccordionSummary-root.Mui-expanded:hover {\r\n    background-color: #d4e9df;\r\n    border-radius: 6px;\r\n  }\r\n\r\n  .MuiAccordionSummary-content {\r\n    margin: 0px;\r\n  }\r\n\r\n  .MuiAccordionDetails-root {\r\n    padding: 10px 0px 10px 20px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: flex-end;\r\n  }\r\n\r\n  .MuiAccordionDetails-root:hover {\r\n    background-color: #d4e9df;\r\n    border-radius: 6px;\r\n  }\r\n\r\n  .MuiAccordionSummary-expandIconWrapper {\r\n    color: #000000;\r\n  }\r\n\r\n  .MuiAccordionSummary-expandIconWrapper.Mui-expanded {\r\n    color: #000000;\r\n    transform: rotate(90deg);\r\n  }\r\n\r\n  &__menu {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 5px 0;\r\n    &__icon {\r\n      color: #000000;\r\n      margin-bottom: 2px;\r\n    }\r\n\r\n    &__title {\r\n      padding-left: 5px;\r\n      padding-top: 5px;\r\n      display: flex;\r\n      color: #000000;\r\n      font-style: normal;\r\n      font-weight: 600;\r\n      font-size: 16px;\r\n      line-height: 20px;\r\n    }\r\n\r\n    &__title__expand {\r\n      padding-left: 0px;\r\n      font-size: 13px;\r\n      display: block;\r\n      // align-items:center;\r\n      color: #000000;\r\n      width: 5px;\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      font-size: 15px;\r\n      line-height: 20px;\r\n    }\r\n\r\n    &__title__expand__detail {\r\n      padding-left: 5px;\r\n      font-size: 13px;\r\n      display: flex;\r\n      align-items: center;\r\n      color: white;\r\n    }\r\n  }\r\n\r\n  &__hrcustom {\r\n    border-top: 1px solid #ffffff !important;\r\n    background-color: #f6f6f7;\r\n  }\r\n}\r\n\r\n.title-tc {\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  line-height: 20px;\r\n  text-transform: uppercase;\r\n  color: #8f3232;\r\n}\r\n\r\n.title-pm {\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n  text-transform: uppercase;\r\n  color: #2b713a;\r\n}\r\n.title-tooltip {\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  line-height: 20px;\r\n  padding: 5px 10px 5px 10px;\r\n  width: 500;\r\n  &:hover {\r\n    background-color: #727b85;\r\n  }\r\n}\r\n.title-tooltip- {\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  line-height: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
